module.exports = __webpack_public_path__ + "img/shiba-head-level1.99a48a4b.png";